<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-select
          v-model="search.status"
          :options="options.type" />

        <date-picker
          v-model="search.join_date_S"
          :position="'right'"
          placeholder="入會日期開始"
        ></date-picker>

        <date-picker
          v-model="search.join_date_E"
          :position="'right'"
          placeholder="入會日期結束"
        ></date-picker>

        <div class="blur">
          <b-form-input
            placeholder="關鍵字"
            v-model="search.blur"
            @keyup.enter="getMember(1)"
            @input="changeFilterValue('blur')" />

          <!-- <div id="blur_info" class="blur-info">i</div> -->
        </div>

        <b-form-input
          v-if="status.moreFilter"
          class="mr-sm-2 mb-sm-0"
          placeholder="契約編號"
          v-model="search.number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務編號"
          v-model="search.sales_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('sales_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務姓名"
          v-model="search.sales_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('sales_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務身分證"
          v-model="search.sales_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('sales_ID_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="要助人姓名"
          v-model="search.pay_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('pay_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="要助人身分證"
          v-model="search.pay_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('pay_ID_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="互助人姓名"
          v-model="search.member_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('member_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="互助人身分證"
          v-model="search.member_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('member_ID_number')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="受款人姓名"
          v-model="search.beneficiary_name"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('beneficiary_name')" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="受款人身分證"
          v-model="search.beneficiary_ID_number"
          @keyup.enter="getMember(1)"
          @input="changeFilterValue('beneficiary_ID_number')" />

        <date-picker
          v-if="status.moreFilter"
          v-model="search.dead_at_S"
          :position="'right'"
          placeholder="身故日期開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.dead_at_E"
          :position="'right'"
          placeholder="身故日期結束"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.accept_at_S"
          :position="'left'"
          placeholder="受理日期開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.accept_at_E"
          :position="'left'"
          placeholder="受理日期結束"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_at_S"
          :position="'left'"
          placeholder="發放日期開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_at_E"
          :position="'left'"
          placeholder="發放日期結束"
        ></date-picker>

        <b-button @click="status.moreFilter = !status.moreFilter" variant="info">{{ status.moreFilter ? '較少' : '更多' }}篩選</b-button>
      </div>

      <div class="btn-area">
        <div class="auto-empty">
          <b-form-checkbox switch size="lg" v-model="status.autoEmpty">自動清空</b-form-checkbox>
        </div>

        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getMember(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <b-tooltip
      target="blur_info"
      placement="top"
      title="契約編號、業務編號、業務姓名、業務身分證、要助人姓名、要助人身分證、互助人姓名、互助人身分證、受款人姓名、受款人身分證" />

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getMember"
      tableId="claimedAidFund"
    >
      <template #cell(sales_number)="row">
        <div class="nowrap">{{ row.item.sales_number }}</div>

        <div class="nowrap">{{ row.item.sales_name }}</div>
      </template>

      <template #cell(member_name)="row">
        <div>{{ row.item.member_name }}</div>

        <div>{{ row.item.member_ID_number }}</div>
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(dead_at)="row">
        {{ convertRocDate(row.item.dead_at) }}
      </template>

      <template #cell(pay_at)="row">
        <span class="link" @click="deceasedClaimInquiryForm(row.item.pay_at)">{{ convertRocDate(row.item.pay_at) }}</span>
      </template>

      <template #cell(seniority)="row">
        {{ row.item.seniority_month }}個月 ({{ row.item.seniority_day }}天)
      </template>

      <template #cell(death_certificate)="row">
        <div class="link death-certificate" @click="openImgModal(row.item, false)">{{ row.item.claim_image }}</div>
      </template>

      <template #cell(payment_schedule)="row">
        <div class="print">
          <b-button
            variant="success"
            size="sm"
            @click="paymentSchedulePreview(row.item)"
          >
            預覽
          </b-button>

          <b-button
            variant="secondary"
            size="sm"
            @click="generatePaymentSchedule(row.item)"
          >
            列印
          </b-button>
        </div>
      </template>

      <template #cell(function)="row">
        <div class="function">
          <b-button
            variant="danger"
            size="sm"
            v-auth="`update`"
            @click="cancellationCompleted(row.item)"
          >
            取消完成
          </b-button>

          <b-button
            variant="warning"
            size="sm"
            v-auth="`update`"
            @click="openImgModal(row.item, true)"
          >
            上傳身故證明
          </b-button>

          <b-dropdown text="更多" variant="primary" size="sm" v-auth="`update`">
            <b-dropdown-item
              v-auth="`update`"
              @click="openUpdateHelpCheckModal(row.item)"
            >
              更新下次互助名單
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </tables-page>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :params="data.pdfParams"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <payment-schedule :data="data.temp_table_data"></payment-schedule>
      </template>
    </html-to-pdf>

    <!-- 圖片 modal -->
    <img-modal
      :img="data.imgUrl"
      :isUpload="status.isUpload"
      v-model="status.imgModal"
      @uploadImage="uploadClaimImage" />

    <!-- 更新墊繳 modal -->
    <update-help-check-modal
      v-model="status.updateHelpCheckModal"
      :data="data.temp_table_data"
      @sumit="updateHelpCheck" />

    <!-- 預覽列印HTML 格式 modal -->
    <preview-print-HTML-format-modal
      v-model="status.previewPrintHTMLFormatModal"
      title="給付明細表預覽"
      :data="data.temp_table_data"
    >
      <payment-schedule :data="data.temp_table_data"></payment-schedule>
    </preview-print-HTML-format-modal>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import datePicker from '@/components/common/DatePicker';
import { convertRocDate, downloadFile, getRightsInterests } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import PaymentSchedule from '@/components/common/PrintTemplate/PaymentSchedule';
import ImgModal from "@/components/common/Modal/imgModal";
import UpdateHelpCheckModal from"./components/modal/UpdateHelpCheckModal";
import PreviewPrintHTMLFormatModal from "@/components/common/Modal/PreviewPrintHTMLFormatModal";

export default {
  name: 'claimedAidFund',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker,
    HtmlToPdf,
    PaymentSchedule,
    ImgModal,
    UpdateHelpCheckModal,
    PreviewPrintHTMLFormatModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '理賠', url: '', isActive: true },
          { name: '已理賠互助金', url: '', isActive: false }
        ]
      },
      options: {
        type: [
          { value: '', text: '全部' },
          { value: 0, text: '正常' },
          { value: 1, text: '身故' },
          { value: 2, text: '停效' },
          { value: 3, text: '除會' },
          { value: 4, text: '墊繳' },
        ]
      },
      search: {
        status: '',
        number: '',
        sales_number: '',
        sales_name: '',
        sales_ID_number: '',
        pay_name: '',
        pay_ID_number: '',
        member_name: '',
        member_ID_number: '',
        beneficiary_name: '',
        beneficiary_ID_number: '',
        blur: '',
        join_date_S: '',
        join_date_E: '',
        dead_at_S: '',
        dead_at_E: '',
        accept_at_S: '',
        accept_at_E: '',
        pay_at_S: '',
        pay_at_E: ''
      },
      status: {
        isNew: false,
        dataReviewModal: false,
        autoEmpty: false,
        resetDom: false,
        autoEmpty: false,
        moreFilter: false,
        imgModal: false,
        isUpload: true,
        updateHelpCheckModal: false,
        previewPrintHTMLFormatModal: false
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "sales_number",
            label: "業務",
            sortable: true
          },
          // {
          //   key: "sales_name",
          //   label: "業務姓名",
          //   sortable: true
          // },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          {
            key: "beneficiary_name",
            label: "受款人",
            sortable: true
          },
          {
            key: "join_date",
            label: "入會日期",
            sortable: true
          },
          {
            key: "dead_at",
            label: "身故日期",
            sortable: true
          },
          {
            key: "pay_at",
            label: "發放日期",
            sortable: true
          },
          {
            key: "pay_count",
            label: "已繳次數",
          },
          {
            key: "seniority",
            label: "年資"
          },
          {
            key: "claim_real_condolence",
            label: "實發慰問金"
          },
          {
            key: "remark",
            label: "註記"
          },
          {
            key: "death_certificate",
            label: "身故證明檔"
          },
          {
            key: "payment_schedule",
            label: "給付明細表"
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_sort: {
          sortBy: '',
          sort: ''
        },
        page: {},
        temp_table_data: {},
        member_id: 0,
        pdfParams: {
          format: 'a5',
          orientation: 'p'
        },
        imgUrl:''
      }
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.contractApi.page);
      this.getMember();
    },
    convertRocDate,
    // 開啟資料審核 modal
    openDataReviewModal(item = null) {
      this.data.temp_table_data = Object.assign({}, item);

      this.status.dataReviewModal = true;
    },
    // 查詢契約
    getMember(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const params = {
        ...this.search,
        'pay_status': 1,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.contractApi.getMember((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data.map(item => {
          return {
            ...item,
            body_tr_bg: getRightsInterests(item.status).bg_class
          }
        });
      }, params)
    },
    // 改變篩選欄位值
    changeFilterValue(search_key) {
      if (this.status.autoEmpty) {
        for (const [key, value] of Object.entries(this.search)) {
          if (key !== search_key) {
            this.$set(this.search, key, '');
          }
        }
      }
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        status: '',
        number: '',
        sales_number: '',
        sales_name: '',
        sales_ID_number: '',
        pay_name: '',
        pay_ID_number: '',
        member_name: '',
        member_ID_number: '',
        beneficiary_name: '',
        beneficiary_ID_number: '',
        blur: '',
        join_date_S: '',
        join_date_E: '',
        dead_at_S: '',
        dead_at_E: '',
        accept_at_S: '',
        accept_at_E: '',
        pay_at_S: '',
        pay_at_E: ''
      }

      this.getMember(1);
    },
    // 預覽給付明細表
    paymentSchedulePreview(item = {}) {
      this.status.previewPrintHTMLFormatModal = true;

      this.data.temp_table_data = Object.assign({}, item);
    },
    // 產生給付明細表
    async generatePaymentSchedule(item = {}) {
      this.status.resetDom = true;

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    },
    /**
     * 取消完成已理賠互助金
     * @param {Object} item 資料
     */
    cancellationCompleted(item = {}) {
      const r = confirm("確定取消完成已理賠互助金？");

      if (r) {
        const params = {
          ...item,
          'claim_check': 0
        }

        this.contractApi.updateMember((response) => {
          const res = response.data;

          if (res.code === 0) {
            const result = { message: `取消完成已理賠互助金`, title: '理賠' };

            this.contractApi.toast(() => {}, result, true);

            this.getMember();
          }
        }, params)

        return true;
      }
      return false;
    },
    // 查詢身故請領表
    deceasedClaimInquiryForm(pickup_at = '') {
      const params = {
        type: 0,
        pay_at_S: pickup_at,
        pay_at_E: pickup_at,
      }

      sessionStorage.setItem("deceasedClaimForm", JSON.stringify(params));

      this.$router.push('/backstage/yf/deceasedClaimForm');
    },
    // 開啟圖片 modal
    openImgModal(item = null, is_upload = true) {
      this.status.imgModal = true;
      this.status.isUpload = is_upload;

      this.data.temp_table_data = Object.assign({}, item);
      this.data.imgUrl = `${process.env.IMAGEPATH}/storage/files/${item.claim_image}`
    },
    /**
     * 上傳身故證明
     * @param {Event} file 檔案
     */
    uploadClaimImage(file) {
      const form_data = new FormData();

      form_data.append('id', this.data.temp_table_data.id);
      form_data.append('files[]', file);

      this.contractApi.uploadClaimImage((response) => {
        const res = response.data;

        if (res.code === 0) {
          const result = { message: `完成上傳身故證明`, title: '理賠' };

          this.contractApi.toast(() => {}, result, true);

          this.status.imgModal = false;
          this.getMember();
        }
      }, form_data)
    },
    // 開啟更新下次互助名單 modal
    openUpdateHelpCheckModal(item = {}) {
      this.data.temp_table_data = Object.assign({}, item);

      this.status.updateHelpCheckModal = true;
    },
    // 更新下次互助名單
    updateHelpCheck() {
      const params = {
        'id': this.data.temp_table_data.id,
        'help_check': this.data.temp_table_data.help_check,
        'pay_birthday': this.data.temp_table_data.pay_birthday,
        'pay_ID_number': this.data.temp_table_data.pay_ID_number,
      }

      this.contractApi.updateMember((response) => {
        const res = response.data;

        if (res.code === 0) {
          const result = { message: `成功更新下次互助名單`, title: '理賠' };

          this.contractApi.toast(() => {}, result, true);

          this.getMember();
        }

        this.status.updateHelpCheckModal = false;
      }, params)
    }
  }
}
</script>

<style lang="scss" scoped>
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .auto-empty {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}

.table-page {
  /deep/ table {
    tbody {
      tr {
        td {
          .nowrap {
            white-space: nowrap;
          }
          .function {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 0.5rem;
          }
          .death-certificate {
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100px;
          }
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/claimedAidFund.vue